import './Team.css';

const members = [
  {
    name: 'Surya',
    role: 'Digital Marketing',
    img: '/team/surya.jpeg',
    emoji: '📣',
    color: '#63ba46',
    accent: 'rgba(99,186,70,0.12)',
    tag: 'Growth Strategist',
    idx: 0,
  },
  {
    name: 'Manoj',
    role: 'Graphic Designer',
    img: '/team/manoj.png',
    emoji: '🎨',
    color: '#3d8c28',
    accent: 'rgba(61,140,40,0.12)',
    tag: 'Visual Architect',
    idx: 1,
  },
  {
    name: 'Fasteena',
    role: 'Digital Marketing',
    img: '/team/teena.jpeg',
    emoji: '📣',
    color: '#2e7d1e',
    accent: 'rgba(46,125,30,0.10)',
    tag: 'Campaign Lead',
    idx: 3,
  },
  {
    name: 'Santhosh',
    role: 'Video Editing',
    img: '/team/santhos.jpg.jpeg',
    emoji: '🎬',
    color: '#8dd674',
    accent: 'rgba(141,214,116,0.15)',
    tag: 'Motion Expert',
    idx: 2,
  },
];

export default function Team() {
  return (
    <section id="team" className="team-section">
      <div className="team-header reveal">
        <span className="section-label">Our People</span>
        <h2 className="section-title">Meet the <em>Dream Team</em></h2>
        <p className="team-sub">
          Passionate experts who live and breathe digital growth — every day, for every brand.
        </p>
      </div>

      <div className="team-grid">
        {members.map((m) => (
          <div
            key={m.name}
            className={`tcard tcard-style-${m.idx % 4}`}
            style={{ '--accent': m.accent, '--col': m.color }}
          >
            <div className="tcard-blob" />
            <div className="tcard-img-wrap">
              <img
                src={m.img}
                alt={m.name}
                onError={e => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="tcard-fallback"><span>{m.emoji}</span></div>
              <div className="tcard-overlay">
                <span className="tcard-tag">{m.tag}</span>
              </div>
            </div>
            <div className="tcard-info">
              <div className="tcard-dot" style={{ background: m.color }} />
              <div>
                <strong className="tcard-name">{m.name}</strong>
                <span className="tcard-role">{m.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
